module.exports = __webpack_public_path__ + "5a65a0906724838c842a05333ec72600.ttf";